import { render, staticRenderFns } from "./ModalSlider.vue?vue&type=template&id=1ce8c71c&"
import script from "./ModalSlider.vue?vue&type=script&lang=js&"
export * from "./ModalSlider.vue?vue&type=script&lang=js&"
import style0 from "./ModalSlider.vue?vue&type=style&index=0&id=1ce8c71c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports